import React, {useEffect, useState, useMemo} from 'react';
import {getConversationFilterCount} from "../../services/api/messaging";
import {debounceTime, from, fromEvent} from "rxjs";
import {map} from "rxjs/operators";
import {FILTER_RELOAD} from "../../services/events";
import {
    ACTIVE,
    ACTIVE_TEXT,
    ARCHIVED,
    UNREAD,
    UNREAD_TEXT,
    ARCHIVED_TEXT
} from "../../services/constants/ConversationFilterType";
import SelectDropdown from "../../components/Input/SelectDropdown";

const ConversationFilters = ({filterOptions, onHandleSelectFilter, onEmptyState}) => {
    const [ready, setReady] = useState(false);
    const [activeFilter, setActiveFilter] = useState([]);

    const conversationFilterItems = useMemo(() => [
        {
            key: ACTIVE,
            text: ACTIVE_TEXT,
        },
        {
            key: UNREAD,
            text: UNREAD_TEXT,
        },
        {
            key: ARCHIVED,
            text: ARCHIVED_TEXT,
        }
    ], []);

    const [newItemsCount, setNewItemsCount] = useState(conversationFilterItems);

    useEffect(() => {
        if (filterOptions) {
            const foundItem = conversationFilterItems.find(item => item.key === filterOptions.status);
            setActiveFilter(foundItem || conversationFilterItems[0]);
        }
        const fetchNewFilterCount = async () => {
            return from(getConversationFilterCount())
                .pipe(
                    map(response => response)
                )
                .subscribe(
                    result => {
                        let isEmpty = true;
                        let items = conversationFilterItems.map((item) => {
                            const number = result[item.key];
                            if (number !== 0) {
                                isEmpty = false;
                            }
                            const existingCount = /\(\d+\)$/.exec(item.text);
                            const countText = ` (${number})`;
                            if (existingCount) {
                                item.text = item.text.replaceAll(existingCount[0], countText);
                            } else {
                                item.text = item.text + countText;
                            }
                            return item;
                        });

                        onEmptyState(isEmpty);
                        setNewItemsCount(items);
                        setReady(true);
                    },
                    error => {
                        console.error('Error fetching messages:', error);
                    }
                );
        };

        fetchNewFilterCount();

        const conversationChangeObservable = fromEvent(document, FILTER_RELOAD);
        const debouncedConversationChangeObservable = conversationChangeObservable.pipe(debounceTime(500));

        const subscription = debouncedConversationChangeObservable.subscribe(() => {
            fetchNewFilterCount();
        });

        return () => {
            subscription.unsubscribe();
        };
    }, [filterOptions, conversationFilterItems, onEmptyState]);

    const handleSelectConversationFilterItem = (item) => {
        // setActiveFilter(item);
        onHandleSelectFilter(item);
    };

    return (<div className="sl-px-5 sl-pb-12 sl-sl-align-center sl-justify-between sl-w-full">
        <SelectDropdown activeFilter={activeFilter} ready={ready} items={newItemsCount}
                        onSelect={handleSelectConversationFilterItem}/>
    </div>);
};

export default ConversationFilters;
